import { render, staticRenderFns } from "./AddAvatars.vue?vue&type=template&id=92aed7c2&"
import script from "./AddAvatars.vue?vue&type=script&lang=js&"
export * from "./AddAvatars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports